export default "__VITE_ASSET__CCw0TTzl__"